import React from 'react'
import * as S from "../Main/portfolio_styles.jsx"
import Footer from "../Footer/footerHome.jsx"
import Projetos from "./CardProjetos.jsx"
import Projeto1 from "../imagens/foto18obra.jpg"
import Projeto2 from "../imagens/foto15obra.jpg"
import Projeto3 from "../imagens/foto21obra.jpg"
import Projeto4 from "../imagens/foto10obra.jpg"
import Projeto5 from "../imagens/foto17obra.jpg"
import Projeto6 from "../imagens/foto5obra.jpg"

export default function Portfolio() {
    return (
        <>
            <S.Main>
                <S.DivTitulo>
                    <h1>Portfolio</h1>
                    <h2>Conheça nossas obras que transformamos com pisos intertravados de alta qualidade</h2>
                </S.DivTitulo>
                <S.DivInfoPortfolio>
                    <S.DivInfo>
                        <S.InfoDestacada>200+</S.InfoDestacada>
                        <S.InfoNaoDestacada>Projetos Realizados</S.InfoNaoDestacada>
                    </S.DivInfo>
                    <S.DivInfo>
                        <S.InfoDestacada>35</S.InfoDestacada>
                        <S.InfoNaoDestacada>Anos de Experiência</S.InfoNaoDestacada>
                    </S.DivInfo>
                </S.DivInfoPortfolio>
                <S.DivTituloProjetos>
                    <h2>Projetos</h2>
                    <p>Conheça alguns dos projetos realizadas com nossos pisos intertravados</p>
                </S.DivTituloProjetos>
                <S.SectionProjetos>
                    <Projetos imagem={Projeto1} local="Santa Rosa, Niterói" />
                    <Projetos imagem={Projeto2} local="Cachambi, Rio de Janeiro" />
                    <Projetos imagem={Projeto3} local="Icaraí, Niterói" /> 
                    <Projetos imagem={Projeto4} local="Barra da Tijuca, Rio de Janeiro" /> 
                    <Projetos imagem={Projeto5} local="Icaraí, Niterói" />
                    <Projetos imagem={Projeto6} local="Itaboraí, Niterói" />
                </S.SectionProjetos>
            </S.Main>
            <Footer />
        </>
    )
}